import { render, staticRenderFns } from "./ContractorsSettlementsPopup.vue?vue&type=template&id=547268a0&"
import script from "./ContractorsSettlementsPopup.vue?vue&type=script&lang=js&"
export * from "./ContractorsSettlementsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports